import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const styles = ({ boxColor, iconColor }) => {
  return makeStyles((theme) => ({
    boxTitle: {
      backgroundColor: boxColor,
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      paddingBlock: theme.spacing(1),
      paddingInline: theme.spacing(2),
    },
    messageInfo: {
      fontWeight: 500,
      overflowWrap: 'break-word',
      whiteSpace: 'pre-line',
    },
    boxContent: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.white,
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body1.fontSize,
      overflowWrap: 'break-word',
      whiteSpace: 'pre-line',
      listStylePosition: 'inside',
      textAlign: 'justify',
      [theme.breakpoints.down('xs')]: {
        '& p > img': {
          width: '100%',
          height: 'auto',
        },
      },
    },
    icon: {
      color: iconColor,
    },
  }))
}

styles.propTypes = {
  description: PropTypes.string,
}

export default styles
